export default "__VITE_ASSET__ed9900ab__"